import React from 'react';

import CompaniesTable from '../components/tables/CompaniesTable';

const SettingsCompaniesPage: React.FC = () => <CompaniesTable />;

export default SettingsCompaniesPage;
